class FtaStickyCart extends HTMLElement {
  connectedCallback() {
    if (!this.sourceContainer) {
      this.section = this.closest('.shopify-section');
      this.sourceContainer = this.parentElement;
      document.body.appendChild(this);
      return;
    }
    if (this.listenersAttached) return;

    this.action = this.querySelector('.fta-sticky-cart__button');
    this.label = this.querySelector('.fta-sticky-cart__button-label');
    this.price = this.querySelector('.fta-sticky-cart__price');
    this.mobilePrice = this.querySelector('.fta-sticky-cart__button-price');
    this.option = this.querySelector('.fta-sticky-cart__option');
    if (!this.action || !this.section) return;
    this.listenersAttached = true;

    this.onAction = () => {
      const primary = document.getElementById(this.dataset.submitId);
      if (primary && !primary.disabled && primary.getAttribute('aria-disabled') !== 'true') {
        primary.click();
      }
    };
    this.onViewportChange = () => this.scheduleRefresh();
    this.onSectionUnload = (event) => {
      if (event.target === this.section || event.target.contains(this.section)) this.remove();
    };
    this.action.addEventListener('click', this.onAction);
    this.section.addEventListener('change', this.onViewportChange);
    window.addEventListener('scroll', this.onViewportChange, { passive: true });
    window.addEventListener('resize', this.onViewportChange);
    document.addEventListener('shopify:section:unload', this.onSectionUnload);

    this.observer = new MutationObserver(() => this.scheduleRefresh());
    this.observer.observe(this.section, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled'],
    });
    this.refresh();
  }

  disconnectedCallback() {
    if (!this.listenersAttached) return;
    this.listenersAttached = false;
    this.action.removeEventListener('click', this.onAction);
    this.section.removeEventListener('change', this.onViewportChange);
    window.removeEventListener('scroll', this.onViewportChange);
    window.removeEventListener('resize', this.onViewportChange);
    document.removeEventListener('shopify:section:unload', this.onSectionUnload);
    this.observer?.disconnect();
    if (this.frame) cancelAnimationFrame(this.frame);
  }

  scheduleRefresh() {
    if (this.frame) return;
    this.frame = requestAnimationFrame(() => {
      this.frame = null;
      this.refresh();
    });
  }

  refresh() {
    if (!this.section?.isConnected) {
      this.remove();
      return;
    }
    const primary = document.getElementById(this.dataset.submitId);
    if (!primary) {
      this.hidden = true;
      return;
    }

    this.action.disabled = primary.disabled || primary.getAttribute('aria-disabled') === 'true';
    const label = primary.querySelector('span')?.textContent?.trim();
    if (label && this.label.textContent.trim() !== label) this.label.textContent = label;

    const priceElement = this.section.querySelector('[id^="price-"] .price');
    const currentPrice = priceElement?.classList.contains('price--on-sale')
      ? priceElement.querySelector('.price__sale .price-item--sale')
      : priceElement?.querySelector('.price__regular .price-item--regular');
    const price = currentPrice?.textContent?.trim() || this.price.textContent.trim();
    if (this.price.textContent.trim() !== price) this.price.textContent = price;
    const buttonPrice = this.action.disabled || !price ? '' : ` · ${price}`;
    if (this.mobilePrice.textContent !== buttonPrice) this.mobilePrice.textContent = buttonPrice;

    const options = [...this.section.querySelectorAll('variant-selects fieldset input:checked, variant-selects select')]
      .map((input) => input.value?.trim())
      .filter(Boolean);
    const selectedOptions = options.join(' · ');
    if (this.option.textContent.trim() !== selectedOptions) this.option.textContent = selectedOptions;

    const purchasePassed = primary.getBoundingClientRect().bottom < 0;
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const footer = document.querySelector('footer.footer') || document.querySelector('footer');
    const beforeFooter = !footer || footer.getBoundingClientRect().top > window.innerHeight;
    const productStillVisible = isMobile ? beforeFooter : this.section.getBoundingClientRect().bottom > 90;
    this.hidden = !(purchasePassed && productStillVisible);
  }
}

if (!customElements.get('fta-sticky-cart')) {
  customElements.define('fta-sticky-cart', FtaStickyCart);
}
